/**
 * Vertical connector line with optional + insert button between flow nodes.
 */
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Plus } from 'lucide-react';

interface FlowConnectorProps {
  onInsert?: (type: 'condition_group' | 'action_block') => void;
  readOnly?: boolean;
}

export function FlowConnector({ onInsert, readOnly }: FlowConnectorProps) {
  return (
    <div className="flex flex-col items-center">
      <div className="w-0.5 h-4 bg-wt-border-subtle" />
      {!readOnly && onInsert ? (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="w-6 h-6 rounded-full bg-wt-bg-secondary border border-wt-border-subtle text-wt-text-muted text-sm flex items-center justify-center hover:border-wt-text-muted transition-colors">
              <Plus className="h-3.5 w-3.5" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onClick={() => onInsert('condition_group')}>
              Add condition
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onInsert('action_block')}>
              Add action
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      ) : (
        <div className="w-1.5 h-1.5 rounded-full bg-wt-border-subtle" />
      )}
      <div className="w-0.5 h-4 bg-wt-border-subtle" />
    </div>
  );
}
